import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Layout, Row } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { Alert, AlertTitle } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import CButton from '../../component/Button';
import { CInput } from '../../component/Input';
import { CBody1, CTitle } from '../../component/Text';

import { reset } from '../../actions/LoginAction';

const useStyles = makeStyles(() => ({
  errorMessage: {
    marginTop: '24px'
  },
  ghost: {
    display: 'none'
  },
  root: {
    '& .MuiFormLabel-root': {
      color: '#000000',
      fontFamily: 'Poppins',
      zIndex: 2
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        backgroundColor: 'white',
        borderColor: '#CAD8FF',
        zIndex: -1
      },
      borderRadius: '10px',
      zIndex: 1
    }
  }
}));

const Reset = () => {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();

  const onReset = () => {
    dispatch(
      reset(
        email,
        () => console.error('[SUBMIT]'),
        () => {
          setErrorMessage(true);
        }
      )
    );
  };

  return (
    <>
      <Layout style={{ backgroundColor: 'white', height: '100%' }}>
        <Content>
          <Row align="middle" justify="center" style={{ minHeight: '100vh' }} type="flex">
            <Col align="start" span={6} style={{ maxWidth: '360px' }}>
              <CTitle
                xstyle={{
                  lineHeight: '24px'
                }}
              >
                Reset Password
              </CTitle>
              <CBody1
                xstyle={{
                  color: '#9BA0AD',
                  fontSize: '14px',
                  fontWeight: 'small'
                }}
              >
                Fill in the email below and we&apos;ll send password reset instructions
                <a
                  href="./login"
                  style={{
                    color: '#5564F8',
                    fontWeight: 700,
                    marginLeft: '6px'
                  }}
                >
                  Back to log in
                </a>
              </CBody1>

              <form
                onSubmit={(e) => onReset(e)}
                style={{
                  backgroundColor: '#F0F4FF',
                  borderRadius: '10px',
                  marginTop: '32px',
                  padding: '40px 24px'
                }}
              >
                <CInput
                  classes={{ root: classes.root }}
                  id="outlined-flexible"
                  label="E-mail"
                  onChange={(event) => setEmail(event.target.value)}
                  size="small"
                  value={email}
                  variant="outlined"
                  xstyle={{
                    width: '100%'
                  }}
                />

                <CButton
                  block
                  onClick={onReset}
                  size="large"
                  type="primary"
                  xstyle={{
                    borderRadius: '20px',
                    fontSize: '14px',
                    fontWeight: 'small',
                    lineHeight: '14px',
                    marginTop: '24px'
                  }}
                >
                  Reset Password
                </CButton>
                <input style={{ display: 'none' }} type="submit" />
                <Alert
                  className={errorMessage ? classes.errorMessage : classes.ghost}
                  onClose={() => setErrorMessage(false)}
                  severity="error"
                >
                  <AlertTitle>Error</AlertTitle>
                  E-mail was incorrect. <strong>Try Again</strong>
                </Alert>
              </form>
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
};

export default Reset;
